import CryptoJS from "crypto-js";
import { io, Socket } from "socket.io-client";

const wsUrl = process.env.REACT_APP_WS || "";

const decryptToken = (token: string, secret: string): string | undefined => {
  try {
    const out = CryptoJS.AES.decrypt(token, secret).toString(CryptoJS.enc.Utf8);
    return out?.trim() ? out : undefined;
  } catch {
    return undefined;
  }
};


const secret = process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$";

/** JWT or AES-decrypted token from localStorage, for Socket.IO auth and emits. */
export function getAuthTokenForSocket(): string | undefined {
  const raw = localStorage.getItem("token");
  if (!raw?.trim()) return undefined;

  const decrypted = decryptToken(raw, secret);
  const candidate = (decrypted?.trim() || raw.trim());
  return candidate || undefined;
}

/**
 * Single Socket.IO client (default namespace, JWT auth).
 * Do not call connect() per screen — import this instance instead.
 */
const socket: Socket = io(wsUrl, {
  auth: (cb) => {
    const token = getAuthTokenForSocket();
    cb(token ? { token } : {});
  },
  autoConnect: typeof window !== "undefined" && !!localStorage.getItem("token"),
  transports: ["websocket", "polling"],
  withCredentials: true,
  reconnection: true,
});

export default socket;
